// Mock data for Skill Spectrum Consulting LLC

export const companyInfo = {
  name: "Skill Spectrum Consulting LLC",
  tagline: "Empowering Businesses Through Knowledge, Technology & Creativity",
  description: "We provide high-quality, reliable, and innovative services that bridge the gap between consulting, technology, and creative design. Our team of skilled professionals and consultants brings diverse expertise across three service divisions, offering comprehensive support to businesses, organizations, and government entities.",
  mission: "Skill Spectrum Consulting LLC provides meaningful services that help businesses grow, connect, thrive and address common business challenges. Showing that skill and dedication are the foundation of excellence.",
  website: "www.skillspectrumconsulting.net",
  generalEmail: "info@skillspectrumconsulting.net",
  entityId: "RBUQNZ6HHDF3",
  cageCode: "15U6A6",
  dunsNumber: "14-030-5878"
};

export const services = [
  {
    id: 1,
    title: "H.R. & Civil Rights Consulting",
    subtitle: "Providing clarity, compliance, and confidence",
    description: "We assist small businesses and established organizations with civil rights requirements, EEO compliance, and problem-solving strategies that promote equity and effective workplace practices.",
    features: [
      "EEO consulting and compliance support",
      "Civil rights training and issue resolution", 
      "Small business networking and partnership guidance",
      "Program evaluation & compliance reporting",
      "Discrimination complaint investigations",
      "Title VI Public Civil Rights Accessibility",
      "H.R. Regulatory Compliant",
      "Section 508 Compliant",
      "Hiring and Onboarding",
      "Ethics Training"
    ],
    contact: {
      name: "Yvette Scott Butler",
      email: "yvettescottbutler@skillspectrumconsulting.net"
    },
    bio: "Equal Employment Opportunity (EEO) & Civil Rights Compliance\n\n• Compliance Monitoring: Ensure adherence to all federal, state, and local EEO laws and regulations to prevent discrimination based on protected characteristics.\n\n• Investigations: Conduct impartial and thorough investigations of discrimination and harassment claims, analyze evidence, and provide actionable recommendations.\n\n• Policy Development & Implementation: Draft, update, and enforce policies that support fair treatment, diversity, and inclusion in the workplace.\n\n• Training & Awareness: Deliver customized training programs to educate leadership and employees on EEO policies, anti-discrimination laws, workplace respect, and complaint procedures.\n\n• Workforce Data Analysis: Evaluate workforce demographics, identify areas of underrepresentation, and develop targeted strategies to promote equity and inclusion.\n\n• Community Engagement: Partner with advocacy groups, community organizations, and workforce development programs to enhance equal opportunity and access to employment.\n\n• Representation & Compliance: Support organizations during audits, legal reviews, and administrative proceedings, ensuring compliance and mitigating risk.",
    image: "https://customer-assets.emergentagent.com/job_consulting-hub-14/artifacts/dqqsibeo_istockphoto-1359838986-612x612.jpg"
  },
  {
    id: 2,
    title: "Cyber Security, Governance, Risk and Compliance",
    subtitle: "Empowering Compliance. Enhancing Cyber Resilience Daily",
    description: "We deliver tailored Cyber Governance, Risk, and Compliance (GRC) services designed to help organizations strengthen their security posture and meet regulatory requirements efficiently and affordably. We understand that every organization's environment and risk tolerance are unique, which is why we take a scalable and business-aligned approach to cyber security.",
    features: [
      "Gap Analysis and Assessment",
      "Audit remediation and continuous monitoring",
      "Policy and Procedural writing",
      "All Major Cyber Security Frameworks (e.g., PCI DSS, NIST, CMMC, ISO 27001)"
    ],
    contact: {
      name: "Frances Kately",
      email: "franceskately@skillspectrumconsulting.net"
    },
    bio: "• Threat Assessment & Risk Mitigation: Identify vulnerabilities and implement strategies to protect against cyber threats, data breaches, and unauthorized access.\n\n• Security Program Development: Design and implement security frameworks that align with industry standards and regulatory requirements.\n\n• Incident Response & Recovery: Establish and execute response protocols to minimize impact and restore operations after security incidents.\n\n• Compliance & Regulatory Support: Ensure adherence to cyber security regulations, standards, and best practices, including federal contracting requirements.\n\n• Training & Awareness Programs: Educate staff on cyber security best practices, phishing prevention, and incident reporting procedures.\n\n• Continuous Monitoring: Implement security monitoring solutions to detect, respond to, and prevent evolving cyber threats.",
    image: "https://customer-assets.emergentagent.com/job_consulting-hub-14/artifacts/3e2hkq0p_Website%20Final%20Image-02.png"
  },
  {
    id: 3,
    title: "Graphic Design & AI Integration",
    subtitle: "Designing the future with creativity and innovation",
    description: "We offer professional graphic design, AI generation, and branding solutions tailored to your business or project. From concept to completion, our creative team delivers high-impact visual communication — all handled remotely for flexibility and collaboration.",
    features: [
      "Logo design, branding, and marketing concept development",
      "AI powered content, prompting and image engineering", 
      "Website, Mobile app, Social media design & templates",
      "Packaging & label design",
      "Product / merch design",
      "Illustration & iconography",
      "Motion & micro-animations"
    ],
    contact: {
      name: "Benjamin Howze II",
      email: "benjaminhowze@skillspectrumconsulting.net"
    },
    bio: "20 plus years Computer Graphic, Graphic Design and Graphic Arts as a freelance designer. Created custom logos and branding for multiple apparel companies. Helped their brands stand out in a competitive market. Beyond apparel, specialized in custom brand concepts and development. Worked closely with entrepreneurs and businesses to bring their creative visions to life. Driven by innovation, resilience, and a passion for pushing boundaries, Benjamin Howze II strives to inspire others to pursue greatness, no matter the obstacles.",
    image: "https://customer-assets.emergentagent.com/job_consulting-hub-14/artifacts/2a8e60l3_Website%20Final%20Image-01.png"
  }
];

export const certifications = [
  "EnCE (EnCase Certified Examiner)",
  "GRCP (Governance Risk and Compliance Professional)",
  "CISSP (Certified Information Systems Security Professional)", 
  "CompTIA Security+",
  "CompTIA A+",
  "EEO Counselor",
  "EEO Investigator"
];

export const naicsCodes = [
  { code: "541519", description: "Other Computer Related Services" },
  { code: "541611", description: "Administrative Management and General Management Consulting Services" },
  { code: "541513", description: "Computer Facilities Management Services" }
];

export const heroImage = "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBvZmZpY2V8ZW58MHx8fHwxNzYxMDE0NTE0fDA&ixlib=rb-4.1.0&q=85";